import { render } from "./UserLogout.vue?vue&type=template&id=68d85a4e&scoped=true"
import script from "./UserLogout.vue?vue&type=script&lang=js"
export * from "./UserLogout.vue?vue&type=script&lang=js"

import "./UserLogout.vue?vue&type=style&index=0&id=68d85a4e&scoped=true&lang=css"

import exportComponent from "/home/ysm/workspace/kft/translate/translate-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68d85a4e"]])

export default __exports__